<template>
  <div>
    <div v-if="isScreenSmAndDown" class="menu-sp">
      <div id="btn" :class="{ open: isOpening }" @click="isOpening = !isOpening">
        <div />
        <div />
        <div />
      </div>
      <div id="menu-bg" :class="{ open: isOpening }" @click="isOpening = false">(メニュー)</div>
      <nav id="menu-body" :class="{ open: isOpening }">
        <ol class="menu-list">
          <li><a @click="onClickTopMoreButton(), (isOpening = false)">TOP</a></li>
          <hr />
          <li><a @click="onClickAboutMoreButton(), (isOpening = false)">ABOUT</a></li>
          <hr />
          <li><a @click="onClickCharacterMoreButton(), (isOpening = false)">CHARACTER</a></li>
          <hr />
          <li><a @click="onClickSystemMoreButton(), (isOpening = false)">SYSTEM</a></li>
        </ol>
        <a href="" @click="isOpening = false"></a>
      </nav>
    </div>
    <!-- </div> -->
    <div v-else class="menu-pc">
      <div class="menu-pc-background">
        <a @click="onClickTopMoreButton()"><v-img class="menu-pc-logo" src="../assets/img/header-pc-logo.png" /> </a>
        <ol class="menu-pc-list">
          <li><a @click="onClickAboutMoreButton()">ABOUT</a></li>
          <li><a @click="onClickCharacterMoreButton()">CHARACTER</a></li>
          <li><a @click="onClickSystemMoreButton()">SYSTEM</a></li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuBtn',
  computed: {
    isScreenSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  data() {
    return {
      isOpening: false,
    };
  },
  methods: {
    onClickTopMoreButton() {
      if (this.$route.path === '/') {
        return;
      }
      this.$router.push('/');
    },
    onClickAboutMoreButton() {
      if (this.$route.path === '/about') {
        return;
      }
      this.$router.push('/about');
    },
    onClickCharacterMoreButton() {
      if (this.$route.path === '/character') {
        return;
      }
      this.$router.push('/character');
    },
    onClickSystemMoreButton() {
      if (this.$route.path === '/system') {
        return;
      }
      this.$router.push('/system');
    },
  },
};
</script>

<style lang="scss" scoped>
#btn {
  position: absolute;
  position: fixed;
  z-index: 101;
  right: 2vh;
  top: 1.5vh;
  margin: 0 0 0 auto;
  height: 8vh;
  width: 8vh;
  transition: all 0.5s;
  div {
    margin: 20% auto 0;
    width: 75%;
    height: 10%;
    background: #ff337b;
    border-radius: 10px;
    transition: all 0.5s;
  }
  &.open {
    div:nth-of-type(1) {
      transform: translateY(2.38vh) rotate(-45deg);
    }
    div:nth-of-type(2) {
      opacity: 0;
    }
    div:nth-of-type(3) {
      transform: translateY(-2.38vh) rotate(45deg);
    }
  }
}

#menu-bg {
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.5;
  z-index: 100;
  &.open {
    display: block;
  }
}
#menu-body {
  z-index: 100;
  position: fixed;
  display: none;
  top: 0;
  right: 0;
  width: 60%;
  height: 100vh;
  transform: translateX(100%);
  background-color: #ff7aa2;
  background-image: radial-gradient(#fe82a8 30%, transparent 30%), radial-gradient(#fe82a8 30%, transparent 30%);
  background-repeat: repeat;
  background-size: 30px 30px;
  background-position: 0 0, 15px 15px;
  text-align: center;
  @media screen and (min-width: 960px) {
    display: inline-block;
  }
  hr {
    margin: 0 auto;
    height: 4px;
    width: 80%;
    background-color: #fff;
    border: none;
  }
  .menu-list {
    margin: 10vh auto;
    list-style: none;
    a {
      display: inline-block;
      text-decoration: none;
      font: bold 4vh 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
      margin: 6.5vh auto;
      color: #fff;
    }
  }
  &.open {
    display: block;
    transform: translateX(0%);
  }
}

.menu-pc {
  position: fixed;
  width: 100%;
  height:5%;
  z-index: 101;
  &-background {
    display: flex;
    background-color: rgba(255, 255, 255, 0.9);
  }
  &-logo {
    position: absolute;
    width: 7%;
    height: 100;
    margin: 0.2% 2%;
    height: auto;
  }
  &-list {
    width: 45%;
    margin-left: 55%;
    list-style: none;
    li {
      position: relative;
      display: inline-block;
      padding: 1.5% 3.5%;
      :hover {
        color: #ff1f64;
      }
      ::after {
        position: absolute;
        bottom: 6px;
        left: 10%;
        content: '';
        width: 80%;
        height: 2px;
        background: #ff1f64;
        transform: scale(0, 1);
        transform-origin: left top;
        transition: transform 0.3s;
      }
      :hover::after {
        transform: scale(1, 1);
      }
    }
    a {
      text-decoration: none;
      font: bold 2vw 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
      color: #919191;
    }
  }
}
</style>
